import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/service/shared/shared.service';

@Component({
  selector: 'app-lnd-setup',
  templateUrl: './lnd-setup.component.html',
  styleUrls: ['./lnd-setup.component.scss'],
})
export class LndSetupComponent  implements OnInit {
  
  buttonColorName: any;
  // Define the reactive form
  attritionSetupForm!: FormGroup;
  fiscalYears: string[] = ['Jan - Feb', 'Feb - Mar', 'Mar - Apr']; // Example fiscal year options

  // Array to hold year objects. Each object contains a 'year' property.
  pmsYears: { year: string }[] = []


  //  FormRepeater in table 
  ageGroupBucketsInput: boolean = false;
  experienceBucketsInput: boolean = false;
  performanceBucketsInput: boolean = false;
  potentialBucketsInput: boolean = false;
  essScoreBucketsInput: boolean = false;
  salaryBucketsInput: boolean = false;
  incrementBucketsInput: boolean = false;
  vpAmountBucketsInput: boolean = false;
  lowerRange: number | any = null;

  maxRange: number | any = null;
  scoreRange: number | any = null;
  errMsgMaxRange: boolean = false;
  showMaxRangeError: boolean = false;
  errorMessage: string = '';
  restrictToEditSetup: boolean = false;
  isInValidMaxRange: boolean = false;
  selectedBucket: string = ''; // Default selected bucket
  showInputsAge: boolean = false;
  showInputsExperience: boolean = false;
  maxRangeAge: number | any = null;
  maxRangeExperience: number | any = null;
  scoreRangeAge: number = 0;
  scoreRangeExperience: number = 0;
  errMsgMaxRangeAge: boolean = false;
  errMsgMaxRangeExperience: boolean = false;
  isInValidMaxRangeAge: boolean = false;
  isInValidMaxRangeExperience: boolean = false;

  constructor(public router: Router,
    private fb: FormBuilder,
    public sharedService: SharedService
  ) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.attritionSetupForm = this.fb.group({
      fiscalYear: [null],  // you can set an initial value if needed
      year: [null, Validators.required]
    });
    this.loadPmsYears();
  }
  loadPmsYears(): void {
    // Sample data; in a real application, this could come from an API.
    this.pmsYears = [
      { year: '2023-2024' },
      { year: '2024-2023' },
      { year: '2025-2024' }
    ];
  }
  onSelectYearForPMSSetup(): void {
    const selectedYear = this.attritionSetupForm.get('year')?.value;
    console.log('Selected year:', selectedYear);

    // Add any additional logic that should occur after a year is selected.
    // For example, you might update other form fields or trigger a service call.
  }
  onSelectFiscalYear(): void {
    const selectedFiscalYear = this.attritionSetupForm.get('fiscalYear')?.value;
    console.log('Selected Fiscal Year:', selectedFiscalYear);
    // Handle the fiscal year selection logic here
  }

  selectedYear: string = '2024-25';

  ratingScale = [
    { rating: 1, definition: 'poor' },
    { rating: 2, definition: 'Average' },
    { rating: 3, definition: 'Good' },
  ];

  experienceBuckets = [
    { lowerEnd: 0, higherEnd: 2 },
    { lowerEnd: 2, higherEnd: 4 },
    { lowerEnd: 4, higherEnd: 6 }
  ];

  addQuestionForEmployee = [
    { questionType: 'Rating ', question: 'How was the programme content' },
    { questionType: 'Rating ', question: 'How was the programme content'  },
    { questionType: 'Open Ended ', question: 'How was the programme content'  }
  ];

  addQuestionForManager=[
    { questionType: 'Rating ', question: 'How was the programme content' },
    { questionType: 'Rating ', question: 'How was the programme content'  },
    { questionType: 'Open Ended ', question: 'How was the programme content'  }
  ]
  potentialBuckets = [
    { lowerEnd: 0, higherEnd: 30 },
    { lowerEnd: 30, higherEnd: 60 },
    { lowerEnd: 60, higherEnd: 90 }
  ];

  essScoreBuckets = [
    { lowerEnd: '0%', higherEnd: '50%' },
    { lowerEnd: '50%', higherEnd: '75%' },
    { lowerEnd: '75%', higherEnd: '100%' }
  ];

  salaryBuckets = [
    { lowerEnd: '0lpa', higherEnd: '7lpa' },
    { lowerEnd: '7lpa', higherEnd: '14lpa' },
    { lowerEnd: '14lpa', higherEnd: '21lpa' }
  ];

  incrementBuckets = [
    { lowerEnd: '0%', higherEnd: '10%' },
    { lowerEnd: '10%', higherEnd: '20%' },
    { lowerEnd: '20%', higherEnd: '30%' }
  ];

  vpAmountBuckets = [
    { lowerEnd: '0k', higherEnd: '10k' },
    { lowerEnd: '10k', higherEnd: '20k' },
    { lowerEnd: '20k', higherEnd: '30k' }
  ];

  onClickback() {
    this.router.navigate(['/home/hrportal/lnd']);

  }


  preventNegative(event: KeyboardEvent): void {
    if (event.key === '-' || event.key === 'e' || event.key === '+') {
      event.preventDefault();
    }
  }

  removeInputs() {
    if (this.selectedBucket === 'ageGroupBuckets') {
      this.ageGroupBucketsInput = false;
      this.resetFormFields();
    } else if (this.selectedBucket === 'experienceBuckets') {

      this.experienceBucketsInput = false;
      this.resetFormFields();
    } else if (this.selectedBucket === 'performanceBuckets') {
      this.performanceBucketsInput = false;
      this.resetFormFields();
    }
    else if (this.selectedBucket === 'potentialBuckets') {
      this.potentialBucketsInput = false;
      this.resetFormFields();
    } else if (this.selectedBucket === 'essScoreBuckets') {
      this.essScoreBucketsInput = false;
      this.resetFormFields();
    } else if (this.selectedBucket === 'salaryBuckets') {
      this.salaryBucketsInput = false;
      this.resetFormFields();
    } else if (this.selectedBucket === 'incrementBuckets') {
      this.incrementBucketsInput = false;
      this.resetFormFields();
    } else if (this.selectedBucket === 'vpAmountBuckets') {
      this.vpAmountBucketsInput = false;
      this.resetFormFields();
    }
    this.ageGroupBucketsInput = false;

    this.experienceBucketsInput = false;

    this.performanceBucketsInput = false;

    this.potentialBucketsInput = false;

    this.essScoreBucketsInput = false;

    this.salaryBucketsInput = false;

    this.incrementBucketsInput = false;

    this.vpAmountBucketsInput = false;
    this.resetFormFields();
  }

  resetFormFields() {
    this.scoreRange = null;
    this.maxRange = null;
    this.isInValidMaxRange = false;
  }
  toggleInputs(bucketType: string) {
    this.selectedBucket = bucketType;
    const selectedBuckets = this.getBucketArray(bucketType);
  
    if (this.selectedBucket === 'ageGroupBuckets') {
      if (this.ageGroupBucketsInput) {
        this.saveData();
      } else {
        if (this.isLastMaxRange100(selectedBuckets)) {
          alert('Max Range of 100 already reached. You cannot add more ranges.');
          return;
        }
        this.scoreRange = selectedBuckets.length > 0 ? Number(selectedBuckets[selectedBuckets.length - 1].higherEnd) : 0;
      }
      this.ageGroupBucketsInput = !this.ageGroupBucketsInput;
  
    } else if (this.selectedBucket === 'experienceBuckets') {
      if (this.experienceBucketsInput) {
        this.saveData();
        this.experienceBucketsInput = false; // Ensure input field is hidden after saving
      } else {
        if (this.isLastMaxRange100(selectedBuckets)) {
          alert('Max Range of 100 already reached. You cannot add more ranges.');
          return;
        }
        this.scoreRange = selectedBuckets.length > 0 ? Number(selectedBuckets[selectedBuckets.length - 1].higherEnd) : 0;
      }
      this.experienceBucketsInput = !this.experienceBucketsInput;
  
    } else if (this.selectedBucket === 'performanceBuckets') {
      if (this.performanceBucketsInput) {
        this.saveData();
        this.performanceBucketsInput = false; // Ensure input field is hidden after saving
      } else {
        if (this.isLastMaxRange100(selectedBuckets)) {
          alert('Max Range of 100 already reached. You cannot add more ranges.');
          return;
        }
        this.scoreRange = selectedBuckets.length > 0 ? Number(selectedBuckets[selectedBuckets.length - 1].higherEnd) : 0;
      }
      this.performanceBucketsInput = !this.performanceBucketsInput;
  
    } else if (this.selectedBucket === 'potentialBuckets') {
      if (this.potentialBucketsInput) {
        this.saveData();
        this.potentialBucketsInput = false; // Ensure input field is hidden after saving
      } else {
        if (this.isLastMaxRange100(selectedBuckets)) {
          alert('Max Range of 100 already reached. You cannot add more ranges.');
          return;
        }
        this.scoreRange = selectedBuckets.length > 0 ? Number(selectedBuckets[selectedBuckets.length - 1].higherEnd) : 0;
      }
      this.potentialBucketsInput = !this.potentialBucketsInput;
  
    } else if (this.selectedBucket === 'essScoreBuckets') {
      if (this.essScoreBucketsInput) {
        this.saveData();
        this.essScoreBucketsInput = false; // Ensure input field is hidden after saving
      } else {
        this.scoreRange = selectedBuckets.length > 0 ? Number(selectedBuckets[selectedBuckets.length - 1].higherEnd) : 0;
      }
      this.essScoreBucketsInput = !this.essScoreBucketsInput;
  
    } else if (this.selectedBucket === 'salaryBuckets') {
      if (this.salaryBucketsInput) {
        this.saveData();
        this.salaryBucketsInput = false; // Ensure input field is hidden after saving
      } else {
        this.scoreRange = selectedBuckets.length > 0 ? Number(selectedBuckets[selectedBuckets.length - 1].higherEnd) : 0;
      }
      this.salaryBucketsInput = !this.salaryBucketsInput;
  
    } else if (this.selectedBucket === 'incrementBuckets') {
      if (this.incrementBucketsInput) {
        this.saveData();
        this.incrementBucketsInput = false; // Ensure input field is hidden after saving
      } else {
        this.scoreRange = selectedBuckets.length > 0 ? Number(selectedBuckets[selectedBuckets.length - 1].higherEnd) : 0;
      }
      this.incrementBucketsInput = !this.incrementBucketsInput;
  
    } else if (this.selectedBucket === 'vpAmountBuckets') {
      if (this.vpAmountBucketsInput) {
        this.saveData();
        this.vpAmountBucketsInput = false; // Ensure input field is hidden after saving
      } else {
        this.scoreRange = selectedBuckets.length > 0 ? Number(selectedBuckets[selectedBuckets.length - 1].higherEnd) : 0;
      }
      this.vpAmountBucketsInput = !this.vpAmountBucketsInput;
    }
  }
  
  isLastMaxRange100(bucketArray: any[]): boolean {
    if (bucketArray.length === 0) {
      return false;
    }
    return Number(bucketArray[bucketArray.length - 1].higherEnd) === 100;
  }
  saveData() {
    this.showMaxRangeError = false;
    if (this.maxRange == null) {
      this.errMsgMaxRange = true;
      return;
    }
    this.errMsgMaxRange = false;
    const maxRangeNum = Number(this.maxRange);

    if (maxRangeNum > 100) {
      alert('Validation failed: max range cannot exceed 100.');
      return;
    }

    const selectedBuckets = this.getBucketArray(this.selectedBucket);

    if (this.isLastMaxRange100(selectedBuckets) && maxRangeNum !== 100) {
      alert('Validation failed: The maximum range must be 100 to proceed.');
      return;
    }

    selectedBuckets.push({
      lowerEnd: this.scoreRange!.toString(),
      higherEnd: this.maxRange.toString()
    });

    this.resetFormFields();
    this.ageGroupBucketsInput = false;
    this.experienceBucketsInput = false;

    this.performanceBucketsInput = false;
    this.potentialBucketsInput = false;
    this.essScoreBucketsInput = false;
    this.salaryBucketsInput = false;
    this.incrementBucketsInput = false;
    this.vpAmountBucketsInput = false;
  }
  getBucketArray(bucketType: string): any[] {
    switch (bucketType) {
      case 'ratingScale': return this.ratingScale;
      case 'experienceBuckets': return this.experienceBuckets;
      case 'addQuestionForEmployee': return this.addQuestionForEmployee;
      case 'potentialBuckets': return this.potentialBuckets;
      case 'essScoreBuckets': return this.essScoreBuckets;
      case 'salaryBuckets': return this.salaryBuckets;
      case 'incrementBuckets': return this.incrementBuckets;
      case 'vpAmountBuckets': return this.vpAmountBuckets;
      default: return [];
    }
  }
  onMaxRangeChange(data: { maxRange: number | string; minRange: number }): void {
    const maxRange = typeof data.maxRange === 'string' ? Number(data.maxRange) : data.maxRange;
    if (isNaN(maxRange) || maxRange <= data.minRange || maxRange <= 0) {
      this.isInValidMaxRange = true;
      this.maxRange = null;
    } else {
      this.isInValidMaxRange = false;
    }
  }


}
